// 代理問い合わせの情報引き込みボタン
$(function () {
  // 二重送信抑止用
  var isExecuting = false;

  // 初期表示処理（弥生IDでログイン済みの場合はユーザー情報を埋める）
  $(document).ready(function () {
    // 初期表示処理が何度も走らない用のフラグ
    var alreadyLoaded = $("#yayoi_pap_inquiry_for_ol_not_call_auto_complete_flg").get(0).value;
    // バリデーションエラーによる自画面リダイレクト、または確認画面からの「戻る」ボタンで何度も初期表示処理が走らない対処
    if (alreadyLoaded == "true") {
      return false;
    }

    // 初期表示済み、または既に引き込み済み
    var cookies = getCookieArray();
    var ysat = cookies["YSAT"];
    // 未ログインの場合、何もせずに処理終了
    if (ysat == null) {
      return false;
    }

    // ログイン済みの場合、APIを呼び出しする
    $.getJSON("/api/get_user_infomations?ysat=" + ysat, (json) => {
      ret_status = json["status_code"];
      if (ret_status == "ERROR" || ret_status == "REDIRECT") {
        // エラー、またはリダイレクトの場合、何もせずに処理を中断する
        return false;
      } else {
        // 取得できた場合は値のセット（空値でなければ設定する）
        if (json["user_info"]["name"] != null && json["user_info"]["name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_name").get(0).value = json["user_info"]["name"];
        }
        if (json["user_info"]["name_kana"] != null && json["user_info"]["name_kana"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_name_kana").get(0).value = json["user_info"]["name_kana"];
        }
        if (json["user_info"]["office_name"] != null && json["user_info"]["office_name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_office_name").get(0).value = json["user_info"]["office_name"];
        }
        if (json["user_info"]["president_name"] != null && json["user_info"]["president_name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_president_name").get(0).value = json["user_info"]["president_name"];
        }
        if (json["user_info"]["tel"] != null && json["user_info"]["tel"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_tel").get(0).value = json["user_info"]["tel"];
        }
        if (json["user_info"]["mail_address"] != null && json["user_info"]["mail_address"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_mail_address").get(0).value = json["user_info"]["mail_address"];
        }
        if (json["user_info"]["post1"] != null && json["user_info"]["post1"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_post_1").get(0).value = json["user_info"]["post1"];
        }
        if (json["user_info"]["post2"] != null && json["user_info"]["post2"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_post_2").get(0).value = json["user_info"]["post2"];
        }
        if (json["user_info"]["prefecture_cd"] != null && json["user_info"]["prefecture_cd"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_prefecture_cd").val(json["user_info"]["prefecture_cd"]);
        }
        if (json["user_info"]["address1"] != null && json["user_info"]["address1"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_address1").get(0).value = json["user_info"]["address1"];
        }

        // 情報引き込んだ旨のアラート表示
        alert("弥生IDの登録情報より、個人情報を自動入力しました。");
        // バリデーションエラーによる自画面リダイレクト時に再度この関数が動作しないようにする
        $("#yayoi_pap_inquiry_for_ol_not_call_auto_complete_flg").get(0).value = true;
      }
    });
  });

  $(".js-paste-user-info").on("click", function () {
    // 二重送信抑止（処理終了後のボタンの活性化 + フラグの処理中フラグの解除）
    $(".js-prevent-double-send").prop("disabled", false);
    isExecuting = true;

    res = confirm(
      "弥生IDの登録情報より事業者情報を自動入力します。\nよろしいでしょうか。\n※現在入力中の内容は失われます。\n※自動入力するには弥生マイポータルへのログインが必要です。\n　未ログインの場合、弥生マイポータルへ移動します。"
    );
    if (res == false) {
      // 二重送信抑止の解除
      $(".js-prevent-double-send").prop("enabled", false);
      isExecuting = false;
      return false;
    }

    var cookies = getCookieArray();
    var ysat = cookies["YSAT"];
    // 未ログインの場合、明示的に空文字を設定（undefined対策）
    if (ysat == null) {
      ysat = "";
    }

    $.getJSON("/api/get_user_infomations?ysat=" + ysat, (json) => {
      ret_status = json["status_code"];
      if (ret_status == "ERROR") {
        // エラー発生時はアラートのみ
        alert("情報が取得できませんでした。");

        // 二重送信抑止の解除
        $(".js-prevent-double-send").prop("enabled", false);
        isExecuting = false;
      } else if (ret_status == "REDIRECT") {
        // 二重送信抑止の解除
        $(".js-prevent-double-send").prop("enabled", false);
        isExecuting = false;

        // 未ログイン（YSATが未設定）の場合、マイポータルログインページへリダイレクト
        window.location.href = json["url"];
      } else {
        // 値のセット（空値でなければ設定する）
        if (json["user_info"]["name"] != null && json["user_info"]["name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_name").get(0).value = json["user_info"]["name"];
        }
        if (json["user_info"]["name_kana"] != null && json["user_info"]["name_kana"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_name_kana").get(0).value = json["user_info"]["name_kana"];
        }
        if (json["user_info"]["office_name"] != null && json["user_info"]["office_name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_office_name").get(0).value = json["user_info"]["office_name"];
        }
        if (json["user_info"]["president_name"] != null && json["user_info"]["president_name"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_president_name").get(0).value = json["user_info"]["president_name"];
        }
        if (json["user_info"]["tel"] != null && json["user_info"]["tel"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_tel").get(0).value = json["user_info"]["tel"];
        }
        if (json["user_info"]["mail_address"] != null && json["user_info"]["mail_address"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_mail_address").get(0).value = json["user_info"]["mail_address"];
        }
        if (json["user_info"]["post1"] != null && json["user_info"]["post1"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_post_1").get(0).value = json["user_info"]["post1"];
        }
        if (json["user_info"]["post2"] != null && json["user_info"]["post2"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_post_2").get(0).value = json["user_info"]["post2"];
        }
        if (json["user_info"]["prefecture_cd"] != null && json["user_info"]["prefecture_cd"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_prefecture_cd").val(json["user_info"]["prefecture_cd"]);
        }
        if (json["user_info"]["address1"] != null && json["user_info"]["address1"].trim() != "") {
          $("#yayoi_pap_inquiry_for_ol_address1").get(0).value = json["user_info"]["address1"];
        }

        // 二重送信抑止の解除
        $(".js-prevent-double-send").prop("enabled", false);
        isExecuting = false;

        // 情報引き込んだ旨のアラート表示
        alert("弥生IDの登録情報より、個人情報を自動入力しました。");
        $("#yayoi_pap_inquiry_for_ol_not_call_auto_complete_flg").get(0).value = true;
      }
    });
  });

  function getCookieArray() {
    var arr = new Array();
    if (document.cookie != "") {
      var tmp = document.cookie.split("; ");
      for (var i = 0; i < tmp.length; i++) {
        var data = tmp[i].split("=");
        arr[data[0]] = decodeURIComponent(data[1]);
      }
    }
    return arr;
  }
});
